import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight, MapPin, House, Hospital, BookOpen, LayoutTemplate } from "lucide-react";
const relatedServices = [{
  title: "מטפל סיעודי בתל אביב",
  path: "/NursingCaregiverInTelAvivWithinFiveHoursPage",
  icon: MapPin
}, {
  title: "מטפל סיעודי בירושלים",
  path: "/NursingCareProviderInJerusalemWithinFiveHoursPage",
  icon: MapPin
}, {
  title: "מטפל סיעודי בבית",
  path: "/NursingCareProviderInHaifaWithinHoursPage",
  icon: House
}, {
  title: "השגחה בבית חולים",
  path: "/NursingCareNowPage",
  icon: Hospital
}, {
  title: "דף הבית",
  path: "/",
  icon: House
}, {
  title: "בלוג",
  path: "/BlogPage",
  icon: BookOpen
}];
export default function RelatedServices() {
  return <section data-section-id="260475" id="שירותים-סיעודיים-בחיפה" className="py-16 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold font-default text-primary mb-10 text-center">
          שירותים סיעודיים משלימים בחיפה
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {relatedServices.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Link to={service.path} className="block h-full group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg">
                <Card className="h-full bg-card hover:bg-accent transition-all duration-300 border border-border shadow-md group-hover:shadow-lg">
                  <CardHeader className="flex flex-row items-center justify-between p-6 h-full">
                    <div className="flex items-center gap-5">
                      <div className="p-3.5 bg-secondary rounded-lg shadow-sm text-secondary-foreground group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                        <service.icon className="w-6 h-6" />
                      </div>
                      <CardTitle className="text-xl font-bold font-default text-foreground group-hover:text-primary transition-colors m-0">
                        {service.title}
                      </CardTitle>
                    </div>
                    <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-transform group-hover:-translate-x-1 shrink-0 mr-4" />
                  </CardHeader>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}